import { useCallback, useState } from 'react';

export function useColumnVisibility() {
  const [userColumnVisibility, setUserColumnVisibility] = useState<Record<string, boolean>>({});

  const handleToggle = useCallback((id: string) => {
    setUserColumnVisibility((prev) => ({ ...prev, [id]: prev[id] === false }));
  }, []);

  return { userColumnVisibility, handleToggle };
}
